import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconInfoCircleOutline } from '@iwoca/icons';
import { Link } from '@iwoca/orion';

import styles from './TrueLayerShareableLink.module.css';
import ShareableLinkModal from '../components/ShareableLinkModal';

const TrueLayerShareableLink = ({ noBankLogin }: { noBankLogin?: boolean }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    tracking.ampli.ctaClick({
      'CTA text': 'Share a link with someone who does',
      URL: window.location.pathname,
    });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const renderContent = () => {
    if (noBankLogin) {
      return (
        <>
          <p data-testid="shareable-title" className={styles.shareableTitle}>
            Don’t know your bank login?{' '}
            <Link className={styles.shareableLink} onClick={handleClick}>
              Share a link with someone who does.
            </Link>
          </p>
          <p className={styles.shareableDescription}>
            If you know this has now been linked, please refresh the page.
          </p>
        </>
      );
    }

    return (
      <>
        <p data-testid="shareable-title" className={styles.shareableTitle}>
          Can’t log in yourself?{' '}
          <Link className={styles.shareableLink} onClick={handleClick}>
            Share a link with someone who can.
          </Link>
        </p>
        <p className={styles.shareableDescription}>
          If you know that the third party has already linked your account,
          refresh the page.
        </p>
      </>
    );
  };

  return (
    <>
      <div className={styles.shareableContainer}>
        <IconInfoCircleOutline className={styles.infoIcon} />
        <div className={styles.shareableInfo}>{renderContent()}</div>
      </div>
      <ShareableLinkModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default TrueLayerShareableLink;
